import React from 'react'
import './Footer.css'
import logo from './images/logo.png'
import { Link } from 'react-scroll'
import { FaWhatsapp, FaFacebook } from 'react-icons/fa'
import { BiPhoneCall } from 'react-icons/bi'

const NAV_LINKS = [
  { label: 'Home',        to: 'Hero',    offset: -90 },
  { label: 'Best Offers', to: 'Plan',    offset: -30 },
  { label: 'About',       to: 'About',   offset: 0   },
  { label: 'Team',        to: 'OurTeam', offset: -90 },
  { label: 'Contact',     to: 'Contact', offset: -90 },
]

const Footer = () => {
  return (
    <footer className='footer' role="contentinfo">
      <div className="footer__glow" aria-hidden="true" />

      <div className="container footer__inner">

        {/* Brand column */}
        <div className="footer__brand">
          <Link to="Hero" smooth duration={500} offset={-90} className="footer__logo-link" aria-label="Back to top">
            <img src={logo} alt="GetNet logo" className="footer__logo" />
          </Link>
          <p className="footer__tagline">
            Lightning-fast broadband for<br />Kopar Khairane &amp; Ghansoli
          </p>
          <div className="footer__social">
            <a href="https://wa.me/+918652816746" className="footer__social-btn" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <FaWhatsapp size={18} />
            </a>
            <a href="https://www.facebook.com/ge.tnet.9279" className="footer__social-btn" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook size={18} />
            </a>
            <a href="tel:+918652816746" className="footer__social-btn" aria-label="Call us">
              <BiPhoneCall size={18} />
            </a>
          </div>
        </div>

        {/* Nav column */}
        <nav className="footer__nav" aria-label="Footer navigation">
          <p className="footer__nav-title">Navigation</p>
          <ul className="footer__nav-list">
            {NAV_LINKS.map(({ label, to, offset }) => (
              <li key={to}>
                <Link to={to} smooth duration={500} offset={offset} className="footer__nav-link">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* Contact column */}
        <div className="footer__contact-col">
          <p className="footer__nav-title">Contact</p>
          <ul className="footer__contact-list">
            <li><a href="tel:+918652816746" className="footer__contact-link">+91 865-281-6746</a></li>
            <li><a href="mailto:GetNet.ISP@gmail.com" className="footer__contact-link">GetNet.ISP@gmail.com</a></li>
            <li className="footer__address">
              LAXMI PARK C-WING, Shop no.05,<br />
              Sector 6, Koparkhairane,<br />
              Navi Mumbai — 400 709
            </li>
          </ul>
        </div>

      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p className="footer__copy">&copy; {new Date().getFullYear()} GetNet Internet Services. All rights reserved.</p>
          <p className="footer__credit">Powered by GetNet</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
